import { ImportCodesSagaWatcher } from './ImportCodes/services/saga';
import { AvailableCodesSagaWatcher } from './AvailableCodes/services/saga';
import { ReceiptsSagaWatcher } from './Receipts/services/saga';
import { SeriesSagaWatcher } from './Series/services/saga';

export const codeBankModuleSaga = [
  ImportCodesSagaWatcher,
  AvailableCodesSagaWatcher,
  ReceiptsSagaWatcher,
  SeriesSagaWatcher,
];
